import { useTranslation } from 'react-i18next';
import { serverTermsWarning } from '../../utils/serverTerms';

/**
 * P-34 (D-184, D-188) - the warning under the server price / cost fields: a cost with no
 * price, or a price below the cost. Never blocks saving. Draws nothing when all is well.
 */
export default function ServerTermsWarning({ fee, cost }: { fee: unknown; cost: unknown }) {
  const { t } = useTranslation();
  const key = serverTermsWarning(fee, cost);
  if (!key) return null;
  return (
    <p role="status" data-server-terms-warning={key} className="text-xs text-warning-700 sm:col-span-2">
      {t(`serverTerms.warn.${key}`)}
    </p>
  );
}
